import { useDisableScrollBody } from '@calendly/ui/hooks/use-disable-scroll-body';
import { useFocusLock } from '@calendly/ui/hooks/use-focus-lock';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { SidePanelContent } from './SidePanelContent';
import { useAnimatedVisibility } from './useAnimatedVisibility';
const sidePanelMobileContainerCss = "s8tyivy";
const sidePanelMobileInnerCss = "s1kngqd2";
const sidePanelMobileEnterCss = "s8qdlud";
const sidePanelMobileExitCss = "sx47zmw";
interface MobileSidePanelPortalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Full-screen fixed overlay for the side panel on mobile (≤896px).
 * Rendered via `createPortal` into `document.body` to escape ancestor stacking contexts.
 * Stays visible through the exit animation via `useAnimatedVisibility`, then hides after `animationend`.
 * `SidePanelContent` remains mounted to preserve outlet state across open/close cycles.
 */
export function MobileSidePanelPortal({
  isOpen,
  onClose
}: MobileSidePanelPortalProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  const {
    isMounted,
    isClosing,
    onAnimationEnd
  } = useAnimatedVisibility(isOpen);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);
  useFocusLock({
    isOpen,
    wrapperRef: ref
  });
  useDisableScrollBody({
    isOpen,
    wrapperRef: ref
  });
  return createPortal(<div ref={ref} className={sidePanelMobileContainerCss} id="shell-mobile-side-panel" role="dialog" aria-modal="true" aria-label="Side panel" hidden={!isMounted}>
      <div className={classNames(sidePanelMobileInnerCss, isClosing ? sidePanelMobileExitCss : sidePanelMobileEnterCss)} onAnimationEnd={onAnimationEnd}>
        <SidePanelContent />
      </div>
    </div>, document.body);
}

require("./MobileSidePanelPortal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MobileSidePanelPortal.tsx");